import { AlertTriangle } from 'lucide-react';

interface ErrorModalProps {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  message?: string;
}

export const ErrorModal = ({
  isOpen,
  onClose,
  title = "Something went wrong",
  message = "At HYPER AI - fast, accurate, safe and secure is everything. the file you selected is not according to our community guidelines. please select/upload different file and try again"
}: ErrorModalProps) => {
  const handleOk = () => {
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-base/90 z-toast flex items-center justify-center p-4">
      <div className="bg-surface border border-subtle rounded-2xl w-full max-w-md">
        {/* Header */}
        <div className="p-6 text-center">
          <div className="w-16 h-16 bg-status-error rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="w-8 h-8 text-white" />
          </div>

          <h2 className="text-xl font-bold text-th-primary mb-2">
            {title}
          </h2>

          <p className="text-th-secondary leading-relaxed">
            {message}
          </p>
        </div>

        {/* Footer */}
        <div className="p-6 pt-0">
          <button
            onClick={handleOk}
            className="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-brand text-surface rounded-xl font-semibold hover:bg-brand/90 transition-all shadow-lg"
          >
            <span>OK</span>
          </button>
        </div>
      </div>

      {/* Background Effects */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-status-error/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-status-warning/10 rounded-full blur-3xl animate-pulse" />
      </div>
    </div>
  );
};
